const FAQAccordionUX = () => {
    if ($('.section-faq-accordion').length <= 0) return null;

    $('.section-faq-accordion').each(function() {
        const $parent = $(this);
        const $sideNav = $parent.find('.side-navigation');
        const $snToggles = $sideNav.find('.sn-group--text');

        const $tocMobToggle = $parent.find('.side-navigation .mob-toggle');

        const $faqToggles = $parent.find('.faq-item .toggle');
        const $loadMoreBtns = $parent.find('.load-more-btn');

        //init
        $sideNav.css({top: `calc(100% - ${$sideNav.height()}px - 112px)`});

        if ($tocMobToggle.hasClass('init-toggled')) {
            $tocMobToggle.next('.sn-tabs').stop().slideDown();
            $tocMobToggle.toggleClass('toggled');
        }

        //faq group toggles
        $snToggles.click(function() {
            if ($(this).closest('.sn-group').hasClass('toggled')) return null;

            let groupId = $(this).closest('.sn-group').data('sn-group-id');

            $parent.find('.sn-group.toggled').removeClass('toggled')
            $parent.find('.faq-group-content.active').removeClass('active')

            $(this).closest('.sn-group').addClass('toggled');
            $parent.find(`.faq-group-content[data-content-group-id="${groupId}"]`).addClass('active');
        });

        $faqToggles.click(function() {
            $(this).toggleClass('toggled');
            $(this).next('.content').stop().slideToggle();
        })

        //mob toggle table of contents
        if ($(window).width() < 1201) {
            $tocMobToggle.click(function() {
                $(this).next('.sn-tabs').stop().slideToggle();
                $(this).toggleClass('toggled');
            })
        }

        //load more button
        $loadMoreBtns.click(function() {
            let $faqGroup = $(this).closest('.faq-group-content');
            $faqGroup.find('.faq-item.hidden:lt(4)').removeClass('hidden');
            if ($faqGroup.find('.faq-item.hidden').length <= 0) {
                $(this).fadeOut();  
            }
        })
    })
}

export default FAQAccordionUX